import React, { FC, useCallback, useState } from 'react';
import { usePaymentRoles } from 'src/models/users/Roles/hooks';
import { useMutation } from '@apollo/client';
import { UPDATE_COMPANY_PRICE_PLAN } from 'src/models/admin/CompanyUsers/queries';
import { IApiCompany } from 'src/models/company/types';
import { useTranslation } from 'react-i18next';
import { confirm, notification, Select } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { PaymentRole } from '@tendium/prom-types';

interface PricePlanSelectProps {
  companyId: string;
  pricePlan: PaymentRole;
}

export const PricePlanSelect: FC<PricePlanSelectProps> = props => {
  const { pricePlan, companyId } = props;
  const { t } = useTranslation();
  const [chosenPricePlan, setChosenPricePlan] = useState(pricePlan);
  const availablePaymentRoles = usePaymentRoles();

  const [updateCompany] = useMutation<
    { updateCompanyPricePlan: IApiCompany },
    { companyId: string; pricePlan: PaymentRole }
  >(UPDATE_COMPANY_PRICE_PLAN);

  const chooseRoles = useCallback(
    p => {
      confirm.confirm({
        title: t('AdminPage.confirmTitle'),
        okText: t('Common.yes'),
        cancelText: t('Common.no'),
        className: modalStyles.confirmModal,
        centered: true,
        onOk() {
          updateCompany({ variables: { companyId, pricePlan: p } })
            .then(r => {
              setChosenPricePlan(r.data?.updateCompanyPricePlan?.pricePlan as PaymentRole);
            })
            .catch(() => {
              notification.error({
                message: t('Common.unknownError'),
                description: t('Common.unknownErrorDesc')
              });
            });
        }
      });
    },
    [companyId, t, updateCompany]
  );

  return (
    <Select
      style={{ width: '100%' }}
      value={chosenPricePlan}
      onSelect={chooseRoles}
      size={'small'}
      dropdownRender={menu => <>{menu}</>}
    >
      {availablePaymentRoles.map(val => (
        <Select.Option value={val} key={val}>
          {t(`FeatureRole.role_${val}`)}
        </Select.Option>
      ))}
    </Select>
  );
};
